import { render, staticRenderFns } from "./SlideHintsInput.vue?vue&type=template&id=488b6482&scoped=true&"
import script from "./SlideHintsInput.vue?vue&type=script&lang=js&"
export * from "./SlideHintsInput.vue?vue&type=script&lang=js&"
import style0 from "./SlideHintsInput.vue?vue&type=style&index=0&id=488b6482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b6482",
  null
  
)

export default component.exports